export enum ItemStockButtonState {
  SOLD_OUT = 'sold_out',
  ORDERABLE = 'orderable',
  BACK_ORDERED = 'back_ordered',
  WAREHOUSE = 'warehouse',
  IN_STOCK = 'in_stock',
  IN_STORE = 'in_store',
}
